"use strict";
/*
 * Created on Thu Aug 03 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Strategy converter
 *
 * @author RV
 */


var StrategySettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(StrategySettingsConverter, _DataObjectConverter_);

  function StrategySettingsConverter() {
    _classCallCheck(this, StrategySettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(StrategySettingsConverter).apply(this, arguments));
  }

  return StrategySettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.StrategySettingsConverter = StrategySettingsConverter;